
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.66675 3.33332H6.16675C4.76662 3.33332 4.06655 3.33332 3.53177 3.6058C3.06137 3.84549 2.67892 4.22794 2.43923 4.69834C2.16675 5.23312 2.16675 5.93319 2.16675 7.33332V14.3333C2.16675 15.7335 2.16675 16.4335 2.43923 16.9683C2.67892 17.4387 3.06137 17.8212 3.53177 18.0608C4.06655 18.3333 4.76662 18.3333 6.16675 18.3333H13.1667C14.5669 18.3333 15.2669 18.3333 15.8017 18.0608C16.2721 17.8212 16.6546 17.4387 16.8943 16.9683C17.1667 16.4335 17.1667 15.7335 17.1667 14.3333V10.8333M7.16673 13.3333H8.56218C8.96983 13.3333 9.17366 13.3333 9.36547 13.2873C9.53553 13.2464 9.6981 13.1791 9.84722 13.0877C10.0154 12.9847 10.1595 12.8405 10.4478 12.5523L18.4167 4.58332C19.1071 3.89296 19.1071 2.77368 18.4167 2.08332C17.7264 1.39296 16.6071 1.39296 15.9167 2.08332L7.94778 10.0523C7.65952 10.3405 7.5154 10.4847 7.41233 10.6528C7.32094 10.802 7.2536 10.9645 7.21278 11.1346C7.16673 11.3264 7.16673 11.5302 7.16673 11.9379V13.3333Z","stroke":"currentColor","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    